const getBrowserLang = () => {
  const locale = navigator.languages != null ? navigator.languages[0] : navigator.language;

  return (locale.length > 2 && locale.slice(0, -3)) || locale;
};

export { getBrowserLang };
